import * as React from 'react';

import {motion} from 'framer-motion';

type Props = {
    preventAnimation?: boolean;
};

export function GrowingDottedLine({preventAnimation}: Props) {
    return (
        <svg viewBox='0 0 120 5'>
            <defs>
                <clipPath id='cut-off-right'>
                    <motion.rect
                        initial={preventAnimation ? false : {width: '0%'}}
                        animate={{width: '100%'}}
                        transition={{delay: 1, type: 'spring', damping: 100, stiffness: 50}}
                        x='0'
                        y='0'
                        width='0'
                        height={5}
                    />
                </clipPath>
            </defs>
            <g fill='#45423E' fillRule='nonzero' clipPath='url(#cut-off-right)'>
                <path d='M67.7 3.5c2 1.2 6.6-.8 8.8.3 1.4-3.4-8.4-2.8-8.8-.3zm-13.2-.7c1.8 1.9 7.4.2 9.8 1 1.2-3.5-8-2.4-9.8-1zM40.3 1.7c1.3 2.7 6.4.9 10.2 1.9-.1-3.7-7.3-2-10.2-1.9zm-13.9.9c3.8.9 7.3.1 10.2.2-.3-3.6-9-1.8-10.2-.2zm-11.7-.5c.9 1.8 4.8.1 7.7.7.9-2.8-7.5-2.6-7.7-.7zM.1 3.3c3.8.2 5.5-.5 10.2-.3-.1-1.7-2.8-2.2-5.4-1.9-2.5.3-5 1.2-4.8 2.2zM148.1 3.8c2.1 1.2 6.6-1.1 8.8-.2.6-1.8-1.5-2.3-3.8-2.2-2.4.3-4.9 1.2-5 2.4zm-13.2-.2c1.8 1.8 7.4 0 9.9.6.5-1.8-1.6-2.2-3.9-2.1-2.4 0-5.1.7-6 1.5zm-14.2-.8c1.3 2.7 6.5.8 10.2 1.7-.2-3.7-7.4-1.9-10.2-1.7zm-14 1c3.8.9 7.4.1 10.2.2-.2-3.6-9-1.8-10.2-.2zm-11.6-.7c.8 1.8 4.8.2 7.6.9 1-2.9-7.4-2.8-7.6-.9zm-14.7.8c3.8.4 5.6-.3 10.2 0 0-3.4-10.6-2.1-10.2 0z' />
            </g>
        </svg>
    );
}
